<template>
	<div id="main" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-form>
			<el-tabs tab-position="left" style="min-height: 100vh;">
				<!-- 基本参数设置 -->
				<el-tab-pane label="基本参数设置">
					<el-divider>基本参数设置</el-divider>
					<el-row :gutter="20">
						<el-col :span="3" class="label">系统名称</el-col>
						<el-col :span="10"><el-input v-model="system.systemName" placeholder="请输入平台名称" @blur="changeSetting('systemName')"></el-input></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">网站首页</el-col>
						<el-col :span="10"><el-input v-model="system.web_index" placeholder="网站首页文件名" @blur="changeSetting('web_index')"></el-input></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">移动端首页</el-col>
						<el-col :span="10"><el-input v-model="system.wap_index" placeholder="移动端首页文件名" @blur="changeSetting('wap_index')"></el-input></el-col>
					</el-row>
					<el-row>
						<el-col :span="3"><span style="line-height: 40px;">网站ico</span></el-col>
						<el-col :span="20">
							<el-upload
								ref="ico"
								:action="HOST + '/admin.document/uploadIco'"
								list-type="picture-card"
								:limit="1"
								:data="{ adminid: JSON.parse($store.state.user.userInfo).id, token: JSON.parse($store.state.user.userInfo).token }"
								:auto-upload="true"
								:file-list="icoShowBack"
								accept=".ico"
							>
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">前台默认语言</el-col>
						<el-col :span="10">
							<el-select v-model="system.default_lang" placeholder="请选择前台默认语言" @change="changeSetting('default_lang')">
								<el-option v-for="(lng,index) in lngList" :key="index" :label="lng.lngtitle" :value="lng.lng"></el-option>
							</el-select>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">网站关闭状态</el-col>
						<el-col :span="10">
							<el-radio-group v-model="system.isclose" @change="changeSetting('isclose')" style="line-height: 40px;">
								<el-radio label="0">启用</el-radio>
								<el-radio label="1">禁用</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">网站关闭文字</el-col>
						<el-col :span="15">
							<el-input type="textarea" rows="5" v-model="system.close_text" placeholder="网站关闭文字" @blur="changeSetting('close_text')"></el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">网站模式</el-col>
						<el-col :span="10">
							<el-radio-group v-model="system.website_type" @change="changeSetting('website_type')" style="line-height: 40px;">
								<el-radio label="0">纯静态页面</el-radio>
								<el-radio label="1">动态生成</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">伪静态</el-col>
						<el-col :span="10">
							<el-radio-group v-model="system.ishtml" @change="changeSetting('ishtml')" style="line-height: 40px;">
								<el-radio label="0">关闭伪静态</el-radio>
								<el-radio label="1">开启伪静态</el-radio>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-divider>静态文件存放目录</el-divider>
					<el-row :gutter="20">
						<el-col :span="3" class="label">pc端目录</el-col>
						<el-col :span="10"><el-input v-model="system.web_html_dir" placeholder="网站首页文件名" @blur="changeSetting('web_html_dir')"></el-input></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">手机端目录</el-col>
						<el-col :span="10"><el-input v-model="system.wap_html_dir" placeholder="网站首页文件名" @blur="changeSetting('wap_html_dir')"></el-input></el-col>
					</el-row>
					<el-divider>版权备案</el-divider>
					<el-row :gutter="20">
						<el-col :span="3" class="label">版权信息</el-col>
						<el-col :span="10"><el-input v-model="system.copyright" placeholder="网站首页文件名" @blur="changeSetting('copyright')"></el-input></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">备案信息</el-col>
						<el-col :span="10"><el-input v-model="system.icp" placeholder="网站首页文件名" @blur="changeSetting('icp')"></el-input></el-col>
					</el-row>
				</el-tab-pane>
				<!-- 基本参数设置结束 -->
				<!-- 内容参数设置 -->
				<el-tab-pane label="内容参数设置">
					<el-form-item label="内容简介获取" :label-width="formLabelWidth" prop="isgetcontent">
						<el-radio-group v-model="system.isgetcontent" @change="changeSetting('isgetcontent')">
							<el-radio label="0">禁用内容简介获取</el-radio>
							<el-radio label="1">启用内容简介获取</el-radio>
						</el-radio-group>
						<template v-if="system.isgetcontent"></template>
					</el-form-item>
				</el-tab-pane>
				<!-- 内容参数设置结束 -->
				<!-- 轮播图参数设置 -->
				<el-tab-pane label="轮播图参数设置">
					<el-row :gutter="20">
						<el-col :span="3" class="label">轮播</el-col>
						<el-col :span="12">
							<div class="block">
								<el-carousel trigger="click" style="width: 400px;" height="200px">
									<el-carousel-item v-for="(item, index) in bannerList" :key="index"><el-image :src="HOST + item.pic"></el-image></el-carousel-item>
								</el-carousel>
							</div>
						</el-col>
						<el-col :span="3"><el-button type="primary" size="medium" @click="dialogVisible = true">上传图片</el-button></el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="3" class="label">轮播列表</el-col>
						<el-col :span="21">
							<el-table ref="multipleTable" :data="bannerList" row-key="baid" border :default-sort="{ prop: 'pid', order: 'ascending' }">
								<el-table-column prop="baid" label="ID" align="center" width="80"></el-table-column>
								<el-table-column prop="pid" label="排序" sortable align="center" width="80"></el-table-column>
								<el-table-column prop="pic" label="图片" align="center">
									<template slot-scope="scope">
										<img v-if="scope.row.pic" :src="HOST + scope.row.pic" style="width:150px;height:auto" />
									</template>
								</el-table-column>
								<el-table-column prop="linktype" label="链接方式" align="center">
									<template slot-scope="scope">
										{{ ['外链', '关联内容', '关联分类'][scope.row.linktype - 1] }}
									</template>
								</el-table-column>
								<el-table-column prop="link" label="链接内容" align="center">
									<template slot-scope="scope">
										{{ scope.row.linktype == 1 ? scope.row.link : scope.row.linktitle }}
									</template>
								</el-table-column>
								<el-table-column prop="addtime" label="上传时间" sortable align="center"></el-table-column>
								<el-table-column prop="starttime" label="起始时间" sortable align="center"></el-table-column>
								<el-table-column prop="endtime" label="失效时间" sortable align="center"></el-table-column>
								<el-table-column label="操作" width="160">
									<template slot-scope="scope">
										<el-button type="primary" size="mini" @click="changeBanner(scope.row)">修改</el-button>
										<el-button type="danger" size="mini" @click="deleteBanner(scope.row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</el-tab-pane>
				<!-- 轮播图参数设置结束 -->
				<!-- 上传参数设置 -->
				<el-tab-pane label="上传参数设置">
					<el-form-item label="上传图片格式" :label-width="formLabelWidth" prop="pic_type">
						<el-input v-model="system.pic_type" placeholder="上传图片格式" @blur="changeSetting('pic_type')"></el-input>
					</el-form-item>
					<el-form-item label="上传视频格式" :label-width="formLabelWidth" prop="video_type">
						<el-input v-model="system.video_type" placeholder="上传视频格式" @blur="changeSetting('video_type')"></el-input>
					</el-form-item>
					<el-form-item label="上传文件格式" :label-width="formLabelWidth" prop="file_type">
						<el-input v-model="system.file_type" placeholder="上传文件格式" @blur="changeSetting('file_type')"></el-input>
					</el-form-item>
					<el-form-item label="后台上传文件限制" :label-width="formLabelWidth" prop="upload_max">
						<el-input v-model="system.upload_max" placeholder="后台上传文件限制" @blur="changeSetting('upload_max')"></el-input>
					</el-form-item>
					<el-form-item label="前台上传文件限制" :label-width="formLabelWidth" prop="web_upload_max">
						<el-input v-model="system.web_upload_max" placeholder="前台上传文件限制" @blur="changeSetting('web_upload_max')"></el-input>
					</el-form-item>
					<el-form-item label="文件夹生成方式" :label-width="formLabelWidth" prop="dir_createtype">
						<el-select v-model="system.dir_createtype" placeholder="请选择图片缩略方式" @change="changeSetting('dir_createtype')">
							<el-option label="按年" value="1"></el-option>
							<el-option label="按年月" value="2"></el-option>
							<el-option label="按年月日" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="文件名生成方式" :label-width="formLabelWidth" prop="file_createtype">
						<el-select v-model="system.file_createtype" placeholder="请选择图片缩略方式" @change="changeSetting('file_createtype')">
							<el-option label="按日期时间戳" value="1"></el-option>
							<el-option label="按随机数编码" value="2"></el-option>
							<el-option label="按上传名" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片背景颜色" :label-width="formLabelWidth" prop="web_upload_max">
						<el-color-picker v-model="system.pic_background_color" @change="changeSetting('pic_background_color')"></el-color-picker>
					</el-form-item>
					<el-form-item label="图片生成质量" :label-width="formLabelWidth" prop="pic_quality">
						<el-select v-model="system.pic_quality" placeholder="请选择关联分类" @change="changeSetting('pic_quality')">
							<el-option label="低" value="1"></el-option>
							<el-option label="高" value="2"></el-option>
							<el-option label="非常高" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="图片缩略图" :label-width="formLabelWidth" prop="iszoom">
						<el-radio-group v-model="system.iszoom" @change="changeSetting('iszoom')">
							<el-radio label="0">禁用缩略图生成</el-radio>
							<el-radio label="1">启用缩略图生成</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="system.iszoom == 1">
						<el-form-item label="图片缩略方式" :label-width="formLabelWidth" prop="zoom_type">
							<el-select v-model="system.zoom_type" placeholder="请选择图片缩略方式" @change="changeSetting('zoom_type')">
								<el-option label="图片等比缩放" value="1"></el-option>
								<el-option label="图片中心缩放" value="3"></el-option>
								<el-option label="图片左对齐缩放" value="4"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="图片缩略宽" :label-width="formLabelWidth" prop="zoom_width">
							<el-input v-model="system.zoom_width" placeholder="图片缩略宽" @blur="changeSetting('zoom_width')"></el-input>
						</el-form-item>
						<el-form-item label="图片缩略高" :label-width="formLabelWidth" prop="zoom_height">
							<el-input v-model="system.zoom_height" placeholder="图片缩略高" @blur="changeSetting('zoom_height')"></el-input>
						</el-form-item>
					</template>
					<el-form-item label="水印功能" :label-width="formLabelWidth" prop="iswatermark">
						<el-radio-group v-model="system.iswatermark" @change="changeSetting('iswatermark')">
							<el-radio label="0">禁用水印</el-radio>
							<el-radio label="1">启用水印</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="system.iswatermark == 1">
						<el-form-item label="水印类型" :label-width="formLabelWidth" prop="mark_type">
							<el-radio-group v-model="system.mark_type" @change="changeSetting('mark_type')">
								<el-radio label="1">图片水印</el-radio>
								<el-radio label="2">文字水印</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="水印放置位置" :label-width="formLabelWidth" prop="mark_position">
							<el-select v-model="system.mark_position" placeholder="请选择水印放置位置" @change="changeSetting('mark_position')">
								<el-option label="顶部居左" value="1"></el-option>
								<el-option label="顶部居中" value="2"></el-option>
								<el-option label="顶部居右" value="3"></el-option>
								<el-option label="中间居左" value="4"></el-option>
								<el-option label="居中" value="5"></el-option>
								<el-option label="中间居右" value="6"></el-option>
								<el-option label="底部居左" value="7"></el-option>
								<el-option label="底部居中" value="8"></el-option>
								<el-option label="底部居右" value="9"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="水印图片" :label-width="formLabelWidth" prop="mark_pic">
							<el-button v-if="!system.mark_pic" size="small" type="primary" @click="choosePic('mark_pic')">上传图片</el-button>
							<div v-else class="upfile">
								<div class="delicon text-right"><i class="el-icon-delete" @click="system.mark_pic=''"></i></div>
								<img v-if="system.mark_pic" :src="HOST + system.mark_pic" alt="" style="width: 150px;height: 150px;" />
							</div>
						</el-form-item>
						<el-form-item label="水印透明度" :label-width="formLabelWidth" prop="mark_opacity">
							<el-select v-model="system.mark_opacity" placeholder="请选择水印透明度" @change="changeSetting('mark_opacity')">
								<el-option label="完全透明" value="0"></el-option>
								<el-option label="一般透明" value="80"></el-option>
								<el-option label="不透明" value="100"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="水印文字" :label-width="formLabelWidth" prop="mark_text">
							<el-input v-model="system.mark_text" placeholder="水印文字" @blur="changeSetting('mark_text')"></el-input>
						</el-form-item>
						<el-form-item label="水印文字大小" :label-width="formLabelWidth" prop="mark_text_size">
							<el-input v-model="system.mark_text_size" placeholder="水印文字大小" @blur="changeSetting('mark_text_size')"></el-input>
						</el-form-item>
						<el-form-item label="水印文字颜色" :label-width="formLabelWidth" prop="mark_text_color">
							<el-color-picker v-model="system.mark_text_color" @change="changeSetting('mark_text_color')"></el-color-picker>
						</el-form-item>
					</template>
					<el-form-item label="上传保存目录" :label-width="formLabelWidth" prop="file_dir">
						<el-input v-model="system.file_dir" placeholder="上传保存目录" @blur="changeSetting('file_dir')"></el-input>
					</el-form-item>
				</el-tab-pane>
				<!-- 上传参数设置结束 -->
				<!-- 网站模板管理 -->
				<el-tab-pane label="网站模板管理">
					<el-form-item label="模板文件夹" :label-width="formLabelWidth" prop="template_dir">
						<el-input v-model="system.template_dir" placeholder="模板文件夹" @blur="changeSetting('template_dir')"></el-input>
					</el-form-item>
					<el-form-item label="移动端模板文件夹" :label-width="formLabelWidth" prop="wap_template_dir">
						<el-input v-model="system.wap_template_dir" placeholder="移动端模板文件夹" @blur="changeSetting('wap_template_dir')"></el-input>
					</el-form-item>
				</el-tab-pane>
				<!-- 邮箱参数设置结束 -->
				<!-- 安全参数设置 -->
				<el-tab-pane label="安全参数设置">
					<el-form-item label="密码过期时间" :label-width="formLabelWidth" prop="password_out_time">
						<el-select v-model="system.password_out_time" placeholder="请选择密码过期时间" @change="changeSetting('password_out_time')">
							<el-option label="永不过期" value="0"></el-option>
							<el-option label="一天过期" value="1"></el-option>
							<el-option label="一周过期" value="2"></el-option>
							<el-option label="一月过期" value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="密码格式" :label-width="formLabelWidth" prop="password_type">
						<el-radio-group v-model="system.password_type" @change="changeSetting('password_type')">
							<el-radio label="0">不限字符</el-radio>
							<el-radio label="1">必须同时包含字母和数字</el-radio>
						</el-radio-group>
					</el-form-item>
					<!-- <el-form-item label="验证码功能" :label-width="formLabelWidth" prop="isverify">
						<el-radio-group v-model="system.isverify" @change="changeSetting('isverify')">
							<el-radio label="0">关闭验证码</el-radio>
							<el-radio label="1">开启验证码</el-radio>
						</el-radio-group>
					</el-form-item> -->
					<template v-if="system.isverify == 1">
						<el-form-item label="验证码背景色" :label-width="formLabelWidth" prop="verify_back_color">
							<el-color-picker v-model="system.verify_back_color" @change="changeSetting('verify_back_color')"></el-color-picker>
						</el-form-item>
						<el-form-item label="验证码文字颜色" :label-width="formLabelWidth" prop="verify_color">
							<el-color-picker v-model="system.verify_color" @change="changeSetting('verify_color')"></el-color-picker>
						</el-form-item>
						<el-form-item label="验证码干扰码" :label-width="formLabelWidth" prop="verify_back_line">
							<el-radio-group v-model="system.verify_back_line" @change="changeSetting('verify_back_line')">
								<el-radio label="0">纯色背景</el-radio>
								<el-radio label="1">增加验证码背景干扰线条</el-radio>
							</el-radio-group>
						</el-form-item>
					</template>
					<el-form-item label="登录错误次数限制" :label-width="formLabelWidth" prop="password_error_time">
						<el-input v-model="system.password_error_time" placeholder="登录错误次数限制" @blur="changeSetting('password_error_time')"></el-input>
					</el-form-item>
					<el-form-item label="错误限制登陆时间" :label-width="formLabelWidth" prop="password_error_delay">
						<el-input v-model="system.password_error_delay" placeholder="错误限制登陆时间" @blur="changeSetting('password_error_delay')"></el-input>
					</el-form-item>
					<el-form-item label="登陆超时时间" :label-width="formLabelWidth" prop="password_over_time">
						<el-input v-model="system.password_over_time" placeholder="登陆超时时间" @blur="changeSetting('password_over_time')"></el-input>
					</el-form-item>
				</el-tab-pane>
				<!-- 安全参数设置结束 -->
				<!-- <el-tab-pane label="时间参数设置">时间参数设置</el-tab-pane> -->
				<!-- 错误页设置 -->
				<el-tab-pane label="错误页设置">
					<el-form-item label="403错误页" :label-width="formLabelWidth" prop="error_page_403">
						<el-input v-model="system.error_page_403" autocomplete="off" placeholder="请选择403错误模板页">
							<template slot="append">
								<el-button icon="el-icon-document" @click="chooseTemplate('error_page_403')">选择模板</el-button>
							</template>
						</el-input>
					</el-form-item>
					<el-form-item label="500错误页" :label-width="formLabelWidth" prop="error_page_500">
						<el-input v-model="system.error_page_500" autocomplete="off" placeholder="请选择500错误模板页">
							<template slot="append">
								<el-button icon="el-icon-document" @click="chooseTemplate('error_page_500')">选择模板</el-button>
							</template>
						</el-input>
					</el-form-item>
				</el-tab-pane>
				<!-- 错误页设置结束 -->
				<!-- 手机参数绑定 -->
				<el-tab-pane label="手机参数绑定">
					<el-form-item label="手机短信功能" :label-width="formLabelWidth" prop="istel">
						<el-radio-group v-model="system.istel" @change="changeSetting('istel')">
							<el-radio label="0">禁用手机短信功能</el-radio>
							<el-radio label="1">启用手机短信功能</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="system.istel==1">
						<el-form-item label="手机签约用户ID" :label-width="formLabelWidth" prop="tel_id">
							<el-input v-model="system.tel_id" placeholder="手机签约用户ID" @blur="changeSetting('tel_id')"></el-input>
						</el-form-item>
						<el-form-item label="短信接口ID" :label-width="formLabelWidth" prop="tel_port">
							<el-input v-model="system.tel_port" placeholder="短信接口" @blur="changeSetting('tel_port')"></el-input>
						</el-form-item>
						<el-form-item label="短信授权KEY码" :label-width="formLabelWidth" prop="tel_key">
							<el-input v-model="system.tel_key" placeholder="短信授权KEY码" @blur="changeSetting('tel_key')"></el-input>
						</el-form-item>
						<el-form-item label="绑定手机号" :label-width="formLabelWidth" prop="tel">
							<el-input v-model="system.tel" placeholder="绑定手机号" @blur="changeSetting('tel')"></el-input>
						</el-form-item>
						<el-form-item label="验证码发送间隔时间" :label-width="formLabelWidth" prop="tel_verify_delay">
							<el-input v-model="system.tel_verify_delay" placeholder="验证码发送间隔时间单位秒" @blur="changeSetting('tel_verify_delay')"></el-input>
						</el-form-item>
						<el-form-item label="验证码发送间隔时间" :label-width="formLabelWidth" prop="tel_verify_delay">
							<el-input v-model="system.tel_verify_delay" placeholder="验证码发送间隔时间单位秒" @blur="changeSetting('tel_verify_delay')"></el-input>
						</el-form-item>
						<el-form-item label="验证码有效时间" :label-width="formLabelWidth" prop="tel_verify_indate">
							<el-input v-model="system.tel_verify_indate" placeholder="验证码有效时间单位秒" @blur="changeSetting('tel_verify_indate')"></el-input>
						</el-form-item>
					</template>
				</el-tab-pane>
				<!-- 手机参数绑定设置 -->
				<!-- 邮箱参数设置 -->
				<el-tab-pane label="邮箱参数设置">
					<el-form-item label="邮件功能" :label-width="formLabelWidth" prop="ismail">
						<el-radio-group v-model="system.ismail" @change="changeSetting('ismail')">
							<el-radio label="0">禁用邮件功能</el-radio>
							<el-radio label="1">启用邮件功能</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="system.ismail==1">
						<el-form-item label="SMTP服务器" :label-width="formLabelWidth" prop="mail_host">
							<el-input v-model="system.mail_host" placeholder="SMTP服务器" @blur="changeSetting('mail_host')"></el-input>
						</el-form-item>
						<el-form-item label="SMTP服务器端口" :label-width="formLabelWidth" prop="mail_port">
							<el-input v-model="system.mail_port" placeholder="SMTP服务器端口" @blur="changeSetting('mail_port')"></el-input>
						</el-form-item>
						<el-form-item label="发件箱" :label-width="formLabelWidth" prop="putmail">
							<el-input v-model="system.putmail" placeholder="发件箱" @blur="changeSetting('putmail')"></el-input>
						</el-form-item>
						<el-form-item label="SMTP用户名" :label-width="formLabelWidth" prop="mail_name">
							<el-input v-model="system.mail_name" placeholder="SMTP用户名" @blur="changeSetting('mail_name')"></el-input>
						</el-form-item>
						<el-form-item label="SMTP密码" :label-width="formLabelWidth" prop="mail_pass">
							<el-input v-model="system.mail_pass" placeholder="SMTP密码" @blur="changeSetting('mail_pass')"></el-input>
						</el-form-item>
					</template>
				</el-tab-pane>
				<!-- 邮箱参数设置结束 -->
			</el-tabs>
		</el-form>
		<el-dialog title="上传轮播图片" :visible.sync="dialogVisible" width="80%" class="text-left">
			<div>
				<el-form>
					<el-form-item label="轮播图片" :label-width="formLabelWidth" prop="pic">
						<el-button v-if="!bannerInfo.pic" size="small" type="primary" @click="choosePic()">上传图片</el-button>
						<div v-else class="upfile">
							<div class="delicon text-right"><i class="el-icon-delete" @click="delImg"></i></div>
							<img v-if="bannerInfo.pic" :src="HOST + bannerInfo.pic" alt="" style="width: 150px;height: 150px;" />
						</div>
					</el-form-item>
					<el-form-item label="背景色值(rgb)" :label-width="formLabelWidth" prop="background">
						<el-input v-model="bannerInfo.background" placeholder="请输入背景色值rgb(xx,xx,xx),选填"></el-input>
					</el-form-item>
					<el-form-item label="访问类型" :label-width="formLabelWidth" prop="linktype">
						<el-radio-group v-model="bannerInfo.linktype">
							<el-radio :label="1">指定链接</el-radio>
							<el-radio :label="2">指定内容</el-radio>
							<el-radio :label="3">指定分类</el-radio>
							<!-- <el-radio :label="4">指定专题</el-radio> -->
						</el-radio-group>
					</el-form-item>
					<el-form-item v-if="bannerInfo.linktype == 1" label="链接地址" :label-width="formLabelWidth" prop="link">
						<el-input v-model="bannerInfo.link" autocomplete="off" placeholder="请输入广告链接地址，地址以http://或者https://开头"></el-input>
					</el-form-item>
					<el-form-item v-if="bannerInfo.linktype == 2" label="访问内容" :label-width="formLabelWidth" prop="linkid">
						<el-input v-model="bannerInfo.linktitle" autocomplete="off" placeholder="请选择访问文件" readonly clearable>
							<template slot="append">
								<el-button class="el-icon-document" @click="chooseDocId"></el-button>
							</template>
						</el-input>
					</el-form-item>
					<el-form-item label="关联分类" v-if="bannerInfo.linktype == 3" :label-width="formLabelWidth" prop="linkid">
						<el-select v-model="bannerInfo.linkid" placeholder="请选择关联分类" @change="linkChange">
							<el-option v-for="item in typeList" :key="item.atid" :label="item.typename" :value="item.tid"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="指定专题" v-if="bannerInfo.linktype == 4" :label-width="formLabelWidth" prop="linkid">
						<el-select v-model="bannerInfo.linkid" placeholder="请选择指定专题">
							<el-option v-for="item in adtypeList" :key="item.atid" :label="item.adtypename" :value="item.atid"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间限制" :label-width="formLabelWidth" prop="istime">
						<el-radio-group v-model="bannerInfo.istime">
							<el-radio :label="1">启用</el-radio>
							<el-radio :label="0">禁用</el-radio>
						</el-radio-group>
					</el-form-item>
					<template v-if="bannerInfo.istime == 1">
						<el-form-item label="起始时间" :label-width="formLabelWidth" prop="starttime">
							<el-date-picker v-model="bannerInfo.starttime" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
						<el-form-item label="失效时间" :label-width="formLabelWidth" prop="endtime">
							<el-date-picker v-model="bannerInfo.endtime" type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</template>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addBanner">确 定</el-button>
			</span>
		</el-dialog>
		<doc-list ref="doclist" @confirm="chooseDocIdConfirm"></doc-list>
		<pic-list ref="piclist" @confirm="choosePicConfirm"></pic-list>
		<tempfile-list ref="templist" @confirm="chooseTempConfirm"></tempfile-list>
	</div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import docList from '../../components/doclist/doclist.vue';
import picList from '../../components/piclist/piclist.vue';
import tempfileList from '../../components/tempfilelist/tempfilelist.vue';
import Sortable from 'sortablejs';
export default {
	components: {
		docList,
		picList,
		tempfileList
	},
	data() {
		return {
			loading: false,
			system: [],
			dialogVisible: false,
			dialogImageUrl: '',
			dialogImgVisible: false,
			bannerList: [],
			formLabelWidth: '140px',
			bannerInfo: {
				background: '',
				pic: '',
				islink: 0,
				linktype: 1,
				link: '',
				linkid: '',
				istime: 0,
				starttime: '',
				endtime: '',
				linktitle: ''
			},
			typeList: [],
			attrname: '', //当前选中的参数名
			tempattr: '' ,//选用模板的系统参数名
			lngList:[],
			icoShowBack:[]
		};
	},
	methods: {
		...mapMutations({
			steAppName: 'auth/setAppName'
		}),
		...mapActions({
			exit: 'auth/logout'
		}),
		getSetting() {
			this.$axios({
				url: this.HOST + '/admin.setting/settingInfo',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'userinfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.system = res.data.list;
						this.lngList = res.data.lngList;
						this.icoShowBack = [{name:'',url:this.HOST+'/favicon.ico'}];
					}
				})
				.catch(err => {});
		},
		addBanner(scope) {
			this.$axios({
				url: this.HOST + '/admin.setting/addBanner',
				method: 'post',
				data: {
					bannerInfo: this.bannerInfo,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.dialogVisible = false;
						this.bannerInfo = {
							background: '',
							pic: '',
							islink: 0,
							linktype: 1,
							link: '',
							linkid: '',
							istime: 0,
							starttime: '',
							endtime: '',
							linktitle: ''
						};
						this.getBannerList();
					}
				})
				.catch(err => {
					this.loading = false;
				});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		getBannerList() {
			this.$axios({
				url: this.HOST + '/admin.setting/getBannerList',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'userinfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.bannerList = res.data.bannerList;
						this.typeList = res.data.typeList;
						let that = this;
						this.rowDrop(that); // 行拖拽排序
					}
				})
				.catch(err => {
					console.log('err');
				});
		},
		// banner拖拽排序
		rowDrop(that) {
			// 此时找到的元素是要拖拽元素的父容器
			const tbody = document.querySelector('.el-table__body-wrapper tbody');
			const _this = that;
			Sortable.create(tbody, {
				// 指定父元素下可被拖拽的子元素
				draggable: '.el-table__row',
				onEnd({ newIndex, oldIndex }) {
					const currRow = _this.bannerList.splice(oldIndex, 1)[0];
					_this.bannerList.splice(newIndex, 0, currRow);
					console.log('行拖拽结果', 'newIndex:' + newIndex, 'oldIndex:' + oldIndex, 'currRow:', currRow);
					_this.bannerList.map((item, index) => {
						item.pid = index;
					});
					// 调用后台拖拽排序接口
					if (newIndex != oldIndex) {
						_this._updateMoveData();
					}
				}
			});
		},
		// 拖拽排序接口
		async _updateMoveData() {
			this.$axios({
				url: this.HOST + '/admin.setting/sortBanner',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					bannerList: this.bannerList
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						console.log('已成功重排序');
						// this.bannerList.sort(function(x,y){
						// 	return x['pid'] - y['pid'];
						// })
					}
				})
				.catch(err => {});
		},
		changeSetting(item) {
			this.$axios({
				url: this.HOST + '/admin.setting/changeSetting',
				method: 'post',
				data: {
					name: item,
					value: this.system[item],
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'userinfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						if (item == 'systemName') {
							this.steAppName(this.system[item]);
						}
					}
				})
				.catch(err => {});
		},
		changeBanner(scope) {
			this.bannerInfo = JSON.parse(JSON.stringify(scope));
			this.dialogVisible = true;
		},
		deleteBanner(scope) {
			this.$confirm('确认删除当前选中图片？')
				.then(_ => {
					this.$axios({
						url: this.HOST + '/admin.setting/deleteBanner',
						method: 'post',
						data: {
							baid: scope.baid,
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'userinfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getBannerList();
							}
						})
						.catch(err => {
							this.loading = false;
						});
				})
				.catch(_ => {});
		},
		chooseDocId() {
			this.$refs.doclist.show();
		},
		chooseDocIdConfirm(e) {
			console.log(e);
			this.bannerInfo.linkid = e.did;
			this.bannerInfo.linktitle = e.title;
		},
		choosePic(attr = '') {
			this.attr = attr;
			this.$refs.piclist.show();
		},
		choosePicConfirm(e) {
			console.log(e,this.attr);
			if (!this.attr) {
				this.bannerInfo.pic = e.files;
			} else {
				this.system[this.attr] = e.files;
				this.changeSetting(this.attr);
			}
		},
		delImg() {
			this.bannerInfo.pic = '';
		},
		linkChange(e) {
			this.bannerInfo.linktitle = this.typeList[e].typename;
		},
		chooseTemplate(attr) {
			this.tempattr = attr;
			this.$refs.templist.show();
		},
		chooseTempConfirm(e) {
			console.log(e);
			this.system[this.tempattr] = e;
			this.changeSetting(this.tempattr);
		}
	},
	mounted() {
		this.getSetting();
		this.getBannerList();
	}
};
</script>

<style>
#myChart {
	width: 95%;
	height: 300px;
	margin: 20px auto;
	border: 1px solid #ccc;
}
.label {
	height: 40px;
	line-height: 40px;
}
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 150px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}
.banner .el-upload-list__item {
	width: 300px !important;
	height: 150px !important;
}
.el-tab-pane {
	padding-left: 20px;
	text-align: left;
}
</style>
